import client from "~/apis/client"

export function fetchCleans() {
  return client.get("/cleans")
}

export function assignCleaner(cleanId, cleanerId) {
  return client.patch(`/cleans/${cleanId}`, { clean: { cleaner_id: cleanerId } })
}

export function updateClean(cleanId, clean) {
  return client.patch(`/cleans/${cleanId}`, { clean })
}

// A turnover clean (bookingId) or an ad-hoc clean (propertyId).
export function createClean({ bookingId, propertyId, cleanerId, kind, status, windowStartsOn, windowEndsOn, scheduledTime, instructions, timingNotes }) {
  return client.post("/cleans", {
    booking_id: bookingId, property_id: propertyId, cleaner_id: cleanerId, kind, status,
    window_starts_on: windowStartsOn, window_ends_on: windowEndsOn,
    scheduled_time: scheduledTime || null, instructions: instructions || null, timing_notes: timingNotes || null,
  })
}

export function transitionClean(cleanId, event) {
  return client.patch(`/cleans/${cleanId}/transition`, { event })
}

export function deleteClean(cleanId) {
  return client.delete(`/cleans/${cleanId}`)
}
